<template>
  <a-form-model
    :model="form"
    ref="form"
    :rules="rules"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 20 }"
  >
    <a-form-model-item label="用户名" prop="userName">
      <a-input v-model="form.userName" placeholder="请输入用户名" />
    </a-form-model-item>
    <a-form-model-item label="账号" prop="accountName">
      <a-input v-model="form.accountName" placeholder="请输入账号" />
    </a-form-model-item>
    <!-- <a-form-model-item label="手机号" prop="phone">
      <a-input v-model="form.phone" placeholder="请输入手机号" />
    </a-form-model-item>
    <a-form-model-item label="邮箱" prop="mail">
      <a-input v-model="form.mail" placeholder="请输入邮箱" />
    </a-form-model-item> -->
    <a-form-model-item label="密码" prop="password" v-if="!formModel">
      <a-input v-model="form.password" placeholder="请输入密码" />
    </a-form-model-item>
    <a-form-model-item label="用户状态" prop="status">
      <a-radio-group v-model="form.status">
        <a-radio :value="1"> 启用 </a-radio>
        <a-radio :value="-1"> 停用 </a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item label="角色名称" prop="userRoles">
      <a-select
        mode="multiple"
        v-model="form.userRoles"
        style="width: 100%"
        placeholder="请选择角色"
      >
        <a-select-option
          v-for="item in roleOptions"
          :value="item.userRoleId"
          :key="item.userRoleId"
        >
          {{ item.userRoleName }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
      <a-button type="primary" @click="onSubmit">
        {{ formModel ? '修 改' : '创 建' }}
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm"> 重 置 </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { createUserApi, updateUserApi } from '@/api/System/User'
import { queryRoleApi } from '@/api/System/Role'
const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
export default {
  data() {
    // let validatePhone = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入手机号'))
    //   } else {
    //     if (phoneReg.test(value)) {
    //       callback()
    //     } else {
    //       callback(new Error('请输入正确的手机号'))
    //     }
    //   }
    // }
    // let validateMail = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入邮箱'))
    //   } else {
    //     if (emailReg.test(value)) {
    //       callback()
    //     } else {
    //       callback(new Error('请输入正确的邮箱格式'))
    //     }
    //   }
    // }
    return {
      form: {
        userName: '',
        accountName: '',
        // phone: '',
        // mail: '',
        password: '',
        status: 1,
        userRoles: []
      },
      rules: {
        userName: [{ required: true, message: '用户名必填', trigger: ['change', 'blur'] }],
        accountName: [{ required: true, message: '账号必填', trigger: ['change', 'blur'] }],
        password: [{ required: true, message: '密码必填', trigger: ['change', 'blur'] }],
        // phone: [
        //   { required: true, message: '手机号必填', trigger: ['change', 'blur'] },
        //   { validator: validatePhone, trigger: ['change', 'blur'] }
        // ],
        // mail: [
        //   { required: true, message: '邮件必填', trigger: ['change', 'blur'] },
        //   { validator: validateMail, trigger: ['change', 'blur'] }
        // ],
        userRoles: [
          { type: 'array', required: true, message: '角色名称必填', trigger: ['change', 'blur'] }
        ]
      },
      roleOptions: []
    }
  },

  props: ['formModel'],
  created() {
    this.getRoleOptions()
  },

  methods: {
    //生产表单数据
    getPostData() {
      let postData = { ...this.form }
      postData.userRoles = [...this.form.userRoles].map((item) => {
        return {
          userRoleId: item
        }
      })
      return postData
    },

    //修改菜单
    async updateUser() {
      const res = await updateUserApi({ ...this.getPostData() })
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    async getRoleOptions() {
      let query = {
        status: 1
      }
      let res = await queryRoleApi(query)
      let { code, msg, data } = res
      if (code == '200') {
        this.roleOptions = data
      } else {
        this.$message.error(msg)
      }
    },

    //添加菜单
    async createUser() {
      const res = await createUserApi({ ...this.getPostData() })
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    resetForm() {
      this.$refs.form.resetFields()
    },

    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formModel) {
            this.updateUser()
          } else {
            this.createUser()
          }
        }
      })
    }
  },

  watch: {
    formModel: {
      handler() {
        if (this.formModel) {
          if (this.formModel.userRoles) {
            let userRoles = this.formModel.userRoles.map((item) => item.userRoleId)
            Object.assign(this.form, this.formModel)
            this.form.userRoles = userRoles
          } else {
            Object.assign(this.form, this.formModel)
          }
        } else {
          Object.assign(this.form, {
            userName: '',
            accountName: '',
            // phone: '',
            // mail: '',
            password: '',
            status: 1,
            userRoles: []
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped></style>
